import { render, staticRenderFns } from "./SideTagsOverdue.vue?vue&type=template&id=2c731200&scoped=true&"
import script from "./SideTagsOverdue.vue?vue&type=script&lang=js&"
export * from "./SideTagsOverdue.vue?vue&type=script&lang=js&"
import style0 from "./SideTagsOverdue.vue?vue&type=style&index=0&id=2c731200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c731200",
  null
  
)

export default component.exports